import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiHomeCard = class PiHomeCard extends Vue {
};
__decorate([
    Prop({ default: "" })
], PiHomeCard.prototype, "cardTitle", void 0);
PiHomeCard = __decorate([
    Component({
        components: {},
    })
], PiHomeCard);
export default PiHomeCard;
